<template>
  <AdminLayout>
    <Head title="Activity Log" />

    <ActivityLog use-large-heading />
  </AdminLayout>
</template>

<script setup>
import AdminLayout from '@/Layouts/AdminLayout.vue'
import { Head } from '@inertiajs/vue3'
import ActivityLog from '@/Components/ActivityLog/ActivityLog.vue'
import { useInitGridState } from '@/Components/DataGrid/Composables/grid-state'

useInitGridState()
</script>
